import { render } from "./BallScaleRippleMultiple.vue?vue&type=template&id=1b9b0a88"
import script from "./BallScaleRippleMultiple.vue?vue&type=script&lang=js"
export * from "./BallScaleRippleMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__